import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiPlus, FiSearch } from 'react-icons/fi';
import { FormGroup, FormControl } from 'react-bootstrap';
import Loading from 'components/Loading';
import Layout from 'components/Layout';
import DayTypeList from 'components/DayTypes';
import DayTypeEditModal from 'components/DayTypes/DayTypeEditModal';
import { showModal, hideModal } from 'actions/modalActions';
import * as calendarsActions from 'actions/calendarsActions';
import Modal from 'components/Modal';
import { withTranslation } from 'react-i18next';
import HelpBanner from 'components/HelpBanner';
import { helpUrls } from 'utils/helpUrls';
// import { errorFormating } from "utils/utils";

class DayTypes extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchDayType: '',
		};

		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewDayTypeModal = this.openNewDayTypeModal.bind(this);
	}

	componentDidMount() {
		this.getDayTypes();
	}

	handleChangeSearch = (event) => {
		this.setState(
			{
				[event.target.id]: event.target.value,
			},
			() => {
				this.getDayTypes();
			}
		);
	};

	async getDayTypes() {
		await this.props.getAllDayTypes(this.state.searchDayType);
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewDayTypeModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('dayTypes.newDayType'),
				style: { width: '400px' },
				content: <DayTypeEditModal handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			'edit'
		);
	}

	getContent = () => {
		if (this.props.loading) {
			return <Loading />;
		}

		if (!this.props.day_types) {
			return this.props.t('dayTypes.errorLoading');
		}

		return <DayTypeList day_types={this.props.day_types} />;
	};

	render() {
		return (
			<>
				<Layout
					configSidebar={true}
					className="page-daytypes"
					context="calendars"
				>
					<div className="heading">
						<h1 className="title">{this.props.t('dayTypes.title')}</h1>
						<div className="heading-help-banner heading-config hidden-sm">
							<HelpBanner
								title={this.props.t('common.needHelp')}
								text={this.props.t('common.helpText')}
								linkText={this.props.t('common.moreInfo')}
								linkHref={helpUrls.day_type}
							/>
						</div>

						<div className="heading-filters">
							<FormGroup
								className="form-group form-search"
								controlId="searchDayType"
							>
								<FormControl
									type="text"
									placeholder={this.props.t('common.searchPlaceholder')}
									value={this.state.searchDayType}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>
						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t('dayTypes.createDayType')}
								onClick={this.openNewDayTypeModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.calendarsReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllDayTypes: (q) => dispatch(calendarsActions.getAllDayTypes(q)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DayTypes));
